import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { helpers } from "../../../../common/lib";
import styles from "../styles";
import makeStyles from "@mui/styles/makeStyles";
import GridColumn from "../GridColumn";
import { Grid } from "@mui/material/";

type Props = {
    asset: any,
    attributes: Array<any>,
    monetaryValues: Array<any>
};

/**
 * Audit Services Component
 */
export default ({ serviceResult }: Props) => {
    const { services } = useSelector((state) => state.typesList);
    const classes = makeStyles(styles)();

    /** Get names which shouldn't be used to display
     * 1. Shackleton 2. Ernest
     */

    const updateServices = useMemo(() => {
        const serviceIds = [];
        services &&
            services.data.map((item) => {
                if (item.name !== "Shackleton" && item.name !== "Ernest")
                    serviceIds.push(item.id);
            });
        return serviceIds;
    }, [services]);

    /** Map services with the name with the typeslist  */
    const imageServices = useMemo(() => {
        const serviceList = {};
        serviceResult.forEach((item) => {
            const serviceName = helpers.getListItemForId(
                services,
                item.service
            ).name;
            if (updateServices.includes(item.service))
                serviceList[serviceName] = item.result;
        });
        return serviceList;
    }, [serviceResult, services, updateServices]);

    const serviceKeys = Object.keys(imageServices);

    return (
        <>
            {serviceKeys.map((item) => (
                <GridColumn
                    key={item}
                    label={item}
                    value={"\u2B24"}
                    cls={
                        imageServices[item] === true
                            ? classes.success
                            : classes.failure
                    }
                />
            ))}
        </>
    );
};
